import "../../styles/SectionFindTable.css"
import {getIcon} from "../../utils/helper";
import styles from "../../styles/layout/layout.module.css";
import {Link} from "react-router-dom";
import DishWidget from "../DishWidget";

const SectionFindTable = () => {
    const dataCards = [
        {
            "title": "Hygienic Food",
            "description": "Wir verwenden stets frische, saubere Zutaten und garantieren hygienische Zubereitung, damit unsere Gäste mit absoluter Sicherheit genießen können.",
            "icon": "/assets/images/features-icon-1.png",
        },
        {
            "title": "Fresh Environment",
            "description": "Unser Restaurant bietet eine frische und angenehme Atmosphäre, die ein entspanntes und vollständiges Genusserlebnis ermöglicht.",
            "icon": "/assets/images/features-icon-2.png"
        },
        {
            "title": "Skilled Chefs",
            "description": "Unser erfahrenes Küchenteam kreiert mit Leidenschaft raffinierte Gerichte, die Tradition und Moderne perfekt verbinden.",
            "icon": "/assets/images/features-icon-3.png"
        },
        {
            "title": "Event & Party",
            "description": "Wir bieten flexible Räumlichkeiten und abwechslungsreiche Menüs für Ihre privaten Feiern und Veranstaltungen.",
            "icon": "/assets/images/features-icon-4.png"
        }
    ];

    return (
        <div className={"wrap-section"}>
            <section className={"section-find-table section"}>
                <div className="container">

                    <div className="quote">”</div>

                    <p className="headline-2 testi-text">
                        Wir möchten Ihnen herzlich für Ihren Besuch im Restaurant Ha Mi danken und freuen uns auch sehr
                        über
                        Ihren Willkommensgruß und Ihre Komplimente. Wir hoffen, Sie in Zukunft begrüßen zu dürfen, damit
                        Sie
                        noch mehr besondere Aromen aus der einzigartigen Kombination der vietnamesischen Küche genießen
                        können.
                    </p>

                    <div className="wrapper">
                        <div className={styles.separator}></div>
                        <div className={styles.separator}></div>
                        <div className={styles.separator}></div>
                    </div>


                </div>
            </section>
            <section className={"section feature about text-center"}>

                <div className="form reservation-form bg-black-10" id={"tisch-reservieren"}>

                    <DishWidget/>

                    <div className="form-right text-center form-find-table">

                        <h2 className="headline-2 text-center">Kontaktieren Sie uns</h2>


                        <div className={styles.separator}></div>
                        <div>
                            <p className="contact-label">Standort</p>
                            <Link to="https://maps.app.goo.gl/dczj2LdVkYREyRVk8">
                                <address className="body-4">
                                    Mönchstraße 01, 09599 Freiberg
                                </address>
                            </Link>
                        </div>
                        <div>
                            <p className="contact-label">Öffnungszeiten</p>
                            <p className="body-4">
                                Montag: Geschlossen<br/>
                                Dienstag-Sonntag: <br/>
                                11:00-15:00 und 17:00-22:00
                            </p>
                        </div>


                        <div>
                            <p className="contact-label">Mittagszeit</p>

                            <p className="body-4">
                                Dienstag-Sonntag: <br/>
                                11:00-15:00
                            </p>
                        </div>

                        <div>
                            <p className="contact-label">Kücheschluss</p>
                            <p className="body-4">
                                21:30
                            </p>
                        </div>
                    </div>

                </div>

                <div className="container">
                    <div className="wrap-title flex-col">
                        <div className="title">
                            <p className="label-2 section-subtitle slider-reveal">Why Choose Us</p>
                            <div className="icon-separator">
                                {getIcon("separator")}
                            </div>

                        </div>
                        <h2 className="headline-1 section-title">Our Strength</h2>
                    </div>
                    <ul className="list-card-feature">
                        {
                            dataCards?.map(({title, description, icon}, index) => {
                                return (
                                    <li className="feature-item" key={index}>
                                        <div className="feature-card">

                                            <div className="card-icon">
                                                <img src={icon} width="100" height="80"
                                                     loading="lazy" alt="icon"/>
                                            </div>

                                            <h3 className="title-2 card-title">{title}</h3>

                                            <p className="label-1 card-text">
                                                {description}
                                            </p>

                                        </div>
                                    </li>
                                )
                            })
                        }


                    </ul>
                    <img src="/assets/images/shape-8.png" width="197" height="194" loading="lazy" alt=""
                         className="shape shape-1"/>
                    <img src="/assets/images/shape-7.png" width="197" height="194" loading="lazy" alt=""
                         className="shape shape-5"/>
                </div>
            </section>

        </div>
    )
}
export default SectionFindTable